import "./style.scss";
import { FC } from "react";
import { AOPSwitzerlandInvoiceData } from "@/src/types/admissionOffice";
import backForInvoiceBlankSwiss from "@/src/assets/admissionOfficePage/back-for-invoice-blank-swiss.webp";

interface AOPPrevProps {
  bodyForPrev: AOPSwitzerlandInvoiceData;
}

const AOPPrev: FC<AOPPrevProps> = ({ bodyForPrev }) => {
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";

  return (
    <div className="admission-office-prev-wrapper">
      <div className="admission-office-prev switzerland invoice">
        <img className="admission-office-prev-background" src={backForInvoiceBlankSwiss} alt="" />
        <div className="admission-office-prev-section number-and-date">
          <span>№ - </span>
          <span>Date: {dateLine}</span>
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName || ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth || ""}</p>
          <p>Nationality: {bodyForPrev.nationality || ""}</p>
          <p>Degree Program: {bodyForPrev.course || ""}</p>
          <p>Pasport Number: {bodyForPrev.passport_number || ""}</p>
          <br />
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction || ""}</p>
          <p>Duration: {bodyForPrev.duration || ""}</p>
          <p>Academic Year: {bodyForPrev.academicYear || ""}</p>
          <p>Year of Study: {bodyForPrev.yearOfStudy || ""}</p>
          <p>Year Study Mode: {bodyForPrev.yearStudyMode || ""}</p>
        </div>
        {bodyForPrev.invoiceBody?.length ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.invoiceBody.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
